var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { "ok-only": true },
      model: {
        value: _vm.displayStatus,
        callback: function($$v) {
          _vm.displayStatus = $$v
        },
        expression: "displayStatus"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("message.promo_code.detail")) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.appliedPromoCode
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-start align-items-center"
              },
              [
                _c("div", [
                  _c("img", {
                    staticClass: "rounded-circle",
                    attrs: {
                      src: _vm.appliedPromoCode.promo_code.image_url
                        ? _vm.appliedPromoCode.promo_code.image_url
                        : "/static/img/logo.png",
                      alt: "",
                      width: "40"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-fill pl-3" }, [
                  _c("h4", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.appliedPromoCode.promo_code.title))
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm.appliedPromoCode.promo_code.province_id ||
            _vm.appliedPromoCode.promo_code.service_id
              ? _c("div", { staticClass: "pt-2" }, [
                  _vm.appliedPromoCode.promo_code.service_id
                    ? _c("div", {
                        staticClass:
                          "d-inline-block border border-info rounded text-small text-info px-2",
                        class: {
                          "-status-alert border-danger text-danger":
                            _vm.appliedPromoCode.promo_code.disabled
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$options.filters.serviceParentName(
                              _vm.appliedPromoCode.promo_code.service_id,
                              _vm.globalState.services
                            )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.appliedPromoCode.promo_code.province_id
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-inline-block border border-orange rounded text-small text-orange px-2",
                          class: {
                            "-status-alert border-danger text-danger":
                              _vm.appliedPromoCode.promo_code.disabled
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.globalState.cities[
                                    _vm.appliedPromoCode.promo_code.province_id
                                  ]
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pt-2 pb-2",
                class: {
                  "-status-offline": _vm.appliedPromoCode.promo_code.disabled
                }
              },
              [
                _c("h3", { staticClass: "mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.appliedPromoCode.promo_code.discount > 0
                          ? _vm.$t("message.promo_code.title", {
                              num: _vm.appliedPromoCode.promo_code.discount
                            })
                          : _vm.appliedPromoCode.promo_code.description
                      ) +
                      "\n      "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            !_vm.appliedPromoCode.is_applied &&
            _vm.appliedPromoCode.status &&
            _vm.appliedPromoCode.status === "not_matched_payment_method"
              ? _c("div", { staticClass: "pt-1 -status-alert" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("message.promo_code.not_matched_payment_method")
                      ) +
                      "\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.appliedPromoCode.promo_code.discount > 0
              ? _c(
                  "div",
                  {
                    staticClass: "pt-1 text-small",
                    class: {
                      "-status-alert": _vm.appliedPromoCode.promo_code.disabled
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$i18n.locale === "th"
                            ? _vm.appliedPromoCode.promo_code.payment_method_th
                            : _vm.appliedPromoCode.promo_code.payment_method_en
                        ) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pt-1 -status-offline text-small" }, [
              _vm._v(
                _vm._s(_vm.$t("message.promo_code.expiring")) + ":\n      "
              ),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm._f("prettyOnlyDate")(
                      _vm.appliedPromoCode.promo_code.expire_date
                    )
                  )
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ac10c03", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac10c03","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/PromoCodeDetailModal.vue
// module id = 1798
// module chunks = 0